import { z } from 'zod';

export const INVITATION_MESSAGE_MAX = 2000;

export const createInvitationInputSchema = z.object({
  email: z.string().trim().toLowerCase().email().max(320),
  role: z.enum(['Owner', 'Admin', 'Editor', 'Viewer']),
  message: z.string().trim().max(INVITATION_MESSAGE_MAX).optional().nullable(),
});
